import React, { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BUSINESS } from "../lib/constants";

const NAV = [
  { href: "#services", label: "Services" },
  { href: "#about", label: "About" },
  { href: "#areas", label: "Areas" },
  { href: "#gallery", label: "Gallery" },
  { href: "#quote", label: "Request Quote" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  const scrollTo = (href) => {
    setOpen(false);
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-[#14110F]/80 backdrop-blur-md border-b border-[#332C27]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between h-20">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          data-testid="site-logo"
          className="flex items-center gap-3"
        >
          <div className="w-11 h-11 rounded-lg overflow-hidden ring-1 ring-[#F5A623]/40 shadow-[0_0_0_3px_rgba(245,166,35,0.08)]">
            <img
              src={BUSINESS.logo}
              alt="5-Star Handyman Service logo"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="leading-tight">
            <div className="font-display text-[#F9FAFB] text-lg font-semibold tracking-tight">
              5-STAR
            </div>
            <div className="text-[10px] tracking-[0.28em] text-[#F5A623] uppercase">
              Handyman · Lehigh Acres FL
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => scrollTo(n.href)}
              className="text-sm text-[#A19D98] hover:text-[#F5A623] transition-colors uppercase tracking-wider font-medium"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${BUSINESS.phoneRaw}`}
            data-testid="header-call-button"
            className="group inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#F5A623] hover:text-[#14110F] hover:bg-[#F5A623] border border-[#F5A623] px-4 py-2 rounded-full transition-colors"
          >
            <Phone className="w-4 h-4" />
            {BUSINESS.phone}
          </a>
          <button
            data-testid="header-quote-cta"
            onClick={() => scrollTo("#quote")}
            className="text-sm font-bold uppercase tracking-wider bg-[#F5A623] text-[#14110F] hover:bg-[#D98C1A] px-5 py-2.5 rounded-full transition-colors"
          >
            Get a Quote
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden text-[#F9FAFB] p-2"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-[#332C27] bg-[#14110F]"
        >
          <div className="max-w-7xl mx-auto px-5 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <button
                key={n.href}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => scrollTo(n.href)}
                className="text-left text-base text-[#F9FAFB] hover:text-[#F5A623] uppercase tracking-wider font-medium py-2"
              >
                {n.label}
              </button>
            ))}
            <a
              href={`tel:${BUSINESS.phoneRaw}`}
              data-testid="mobile-call-button"
              className="mt-2 text-sm font-bold uppercase tracking-wider bg-[#F5A623] text-[#14110F] px-5 py-3 rounded-full text-center"
            >
              Call {BUSINESS.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
